document.addEventListener("DOMContentLoaded", function() {
  const tabs = document.querySelectorAll(".tab-link");
  const contents = document.querySelectorAll(".tab-content");

  tabs.forEach((tab, index) => {
    tab.addEventListener("click", function() {
      tabs.forEach(t => t.classList.remove("active"));
      contents.forEach(c => c.classList.remove("active"));

      tab.classList.add("active");
      document.getElementById("tab-" + index).classList.add("active");
    });
  });
});


document.addEventListener('click', function (e) {
  const link = e.target.closest('a[href*="#"]');
  if (!link) return;

  const linkUrl = new URL(link.href, window.location.origin);
  const currentUrl = new URL(window.location.href);

  // Same page + different hash
  if (
    linkUrl.pathname === currentUrl.pathname &&
    linkUrl.hash &&
    linkUrl.hash !== currentUrl.hash
  ) {
    // Close ALL open mega menus (details elements)
    document.querySelectorAll('details.mega-menu[open]').forEach(menu => {
      menu.removeAttribute('open');
    });
  }
});


(function () {

  function normalizeHash() {
    const path = window.location.pathname;
    const hash = window.location.hash;

    // Only for Driving Range page
    if (path === '/pages/driving-range') {

      if (hash === '#range-technologies') {
        const newHash = '#range-technology-automation-featured-products';

        // Prevent infinite loop
        if (window.location.hash !== newHash) {
          window.location.hash = newHash;
        }
      }
    }
  }

  // Run on initial page load
  document.addEventListener('DOMContentLoaded', normalizeHash);

  // Run when hash changes (menu click, manual change, back button)
  window.addEventListener('hashchange', normalizeHash);

})();



